import "../css/ButtonIconV.css";

export default function ButtonIconV({ onClick, disabled, icon, text }) {
  return (
    <button
      className="action"
      onClick={onClick}
      disabled={disabled}
      tabIndex={-1}
    >
      <img
        src={icon}
        loading="lazy"
        alt="Icon"
        className="patient-action-icon"
        style={{ pointerEvents: "none" }}
      />
      <span>{text}</span>
    </button>
  );
}
